import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { PremioConsumidorModel } from '../../../shared/index';
import { BilheteConsumidorService, BilheteConsumidorModel } from '../../../restrito/consumidor/shared/index';
import { PremioSorteioService } from '../../../shared/service/premio-sorteio.service';
import { FiltroObterBilhetesSorteioConsumidor } from '../../../shared/model/filtro-obter-bilhetes-sorteio-consumidor';


@Component({
  selector: 'app-lista-bilhete-participante',
  templateUrl: './lista-bilhete-participante.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class ListaBilheteParticipanteComponent implements OnInit {

  public consumidorId: number;
  public sorteioId: number;
  public pagina = 1;
  public totalBilhetes = 0;
  public tamanhoPagina = 10;
  public bilhetes: Array<BilheteConsumidorModel> = Array<BilheteConsumidorModel>();
  public premios: Array<PremioConsumidorModel> = Array<PremioConsumidorModel>();

  constructor(private readonly bilheteConsumidorService: BilheteConsumidorService,
              private readonly premioSorteioService: PremioSorteioService) { }

  ngOnInit() {

    const s: Subscription = this.bilheteConsumidorService.bilhetesChange
    .subscribe(
      (data: Array<BilheteConsumidorModel>) => {
        this.totalBilhetes = this.bilheteConsumidorService.totalBilhetes;
        this.bilhetes = data;
      },
      (erro) => {
      },
      () => {
        s.unsubscribe();
      }
    );

    this.totalBilhetesConsumidor();
  }

  pageChange(event: number): void {
    this.pagina = event;
    this.totalBilhetesConsumidor();
  }

  totalBilhetesConsumidor() {
 
    let filtro = new FiltroObterBilhetesSorteioConsumidor();
    filtro.consumidorId = this.consumidorId;
    filtro.sorteioId = this.sorteioId;
    filtro.page = this.pagina;
    filtro.pageSize = this.tamanhoPagina;
 
    this.bilheteConsumidorService.getBilhetesSorteioConsumidor(filtro);
  }
}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/lista-bilhete-participante/lista-bilhete-participante.component.ts